<template>

  <xolas-table
    :title="(name ? name : 'Tower Supplier') + (status ?  ': ' +status : '') "

    :url="supplierId ? urlSupplier :  urlGroup"
    :fields="fields"
    ref="towerSupplierSites"
    table-ref="towerSupplierSitesDataTable">

    <template #show="scope">
      <el-button type="text" icon="fa fa-angle-double-down" @click="showSite(scope.rowData.site_id)">&nbsp;Show</el-button>
    </template>

  </xolas-table>

</template>


<script>

import DateMixins from '@/mixins/DateMixins'

export default {

  mixins: [DateMixins],

  props: {
    name: {
      type: String,
      default: null
    },

    siteGroup: {
      type: String,
      default: null
    },

    supplierId: {
      type: Number,
      default: null
    },

    status: {
      type: String,
      default: null
    }
  },


  methods: {

    showSite (id) {
      alert('site id: ' + id)
    }

  },



  data () {
    return {

      urlSupplier: 'report/tower-supplier/sites/' + this.supplierId + (this.status ? '/' + this.status : ''),
      urlGroup: 'report/site-groups/sites/' + this.siteGroup + (this.status ? '/' + this.status : ''),
      rowData: null,

      // minWidth hints mirror the pre-migration vuetable-2 render, measured at
      // 1504px viewport (.context/xol-234-baselines/metrics.json,
      // popup-sites-report[0]) — el-table distributes un-sized columns
      // equally, which does not match the legacy content-based auto layout.
      // 'status' has no baseline width — the measured render had it gated off
      // (this.status set, siteGroup falsy), same case Fix 2 corrects below —
      // so no minWidth is added for it here.
      fields: [
        {
          title: 'Status',
          name: 'status',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          visible: Boolean(!this.status || this.siteGroup)
        },
        {
          title: 'Site Group',
          name: 'siteGroup',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          minWidth: 134
        },
        {
          title: 'Site ID',
          name: 'siteId',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: 198
        },
        {
          title: 'Site Name',
          name: 'siteName',
          minWidth: 572
        },
        {
          title: 'Handover',
          name: 'handover',
          callback: this.formatDate,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: 153
        },
        {
          title: 'Structure',
          name: 'structure',
          visible: Boolean(this.supplierId),
          minWidth: 219
        },
        {
          title: 'Height',
          name: 'height',
          visible: Boolean(this.supplierId),
          minWidth: 86
        }
/*        ,
        {
          name: '__slot:show'
        }
*/
      ]
    }
  }
}
</script>

<!-- Dev-parity: zero horizontal cell padding + tight line-height to match the
     legacy vuetable-2 render (dev <td> uses `12px 0`). -->
<style scoped>
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { padding-left: 0; padding-right: 0; }
::v-deep .el-table th .cell { white-space: normal; }
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { line-height: 1.25; }
</style>
